/* eslint-disable no-shadow */
import { SET_PROGRESS } from './action-modulation.type';

export const state = {
  showProgress: false,
};

export const actions = {
  [SET_PROGRESS](context, flag) {
    return context.commit(SET_PROGRESS, flag);
  },
};

/* eslint no-param-reassign: ["error", { "props": false }] */
export const mutations = {
  [SET_PROGRESS](state, flag) {
    state.showProgress = flag;
  },
};

export default {
  state,
  actions,
  mutations,
};



// WEBPACK FOOTER //
// ./src/store/utils.module.js